import { OfferDisplayStatus } from './offer-display-status.enum';

/** Status chip styling, same shape as `products/constants/archive-status.ts`. */
export const OFFER_DISPLAY_STATUS: Record<OfferDisplayStatus, { label: string; lamp: string; chip: string }> = {
  [OfferDisplayStatus.NOT_SENT]: {
    label: 'Entwurf',
    lamp: 'bg-[#F59E0B] shadow-[0_0_0_3px_rgba(245,158,11,0.16)]',
    chip: 'bg-amber-50 text-amber-700 border border-amber-200'
  },
  [OfferDisplayStatus.OPEN]: {
    label: 'Offen',
    lamp: 'bg-[#16A34A] shadow-[0_0_0_3px_rgba(22,163,74,0.16)]',
    chip: 'bg-green-50 text-green-700 border border-green-200'
  },
  [OfferDisplayStatus.EXPIRED]: {
    label: 'Abgelaufen',
    lamp: 'bg-[#CE0909] shadow-[0_0_0_3px_rgba(206,9,9,0.16)]',
    chip: 'bg-red-50 text-red-700 border border-red-200'
  },
  [OfferDisplayStatus.ACCEPTED]: {
    label: 'Angenommen',
    lamp: 'bg-[#0891B2] shadow-[0_0_0_3px_rgba(8,145,178,0.16)]',
    chip: 'bg-cyan-50 text-cyan-700 border border-cyan-200'
  },
  [OfferDisplayStatus.REVOKED]: {
    label: 'Zurückgezogen',
    lamp: 'bg-[#888888] shadow-[0_0_0_3px_rgba(136,136,136,0.16)]',
    chip: 'bg-[#F2F4F7] text-[#667085] border border-[#E4E7EC]'
  }
};
